module.exports = __webpack_public_path__ + "img/ziliao_banner.e12acaf3.jpg";